import { JsonObject, JsonProperty } from "ta-json";

import Link from "../link";
import { EntityResource } from "./entity-resource";
import Resource from "./resource";

@JsonObject()
export class SearchDocumentResource extends Resource {
    @JsonProperty("link")
    link: Link;

    @JsonProperty("entity")
    entity: EntityResource;
}
